import styled from "styled-components";

export const TabsContainer = styled.ul`
  background-color: #ffffff;
  display: flex;
  justify-content: space-around;
  margin-top: 0;
  padding: 0;
  border-bottom: 1px solid #e4e4e4;
`;

export const TabItem = styled.li`
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
  padding: 15px 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  > img {
    display: block;
    margin-bottom: 8px;
  }

  > span {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.6px;
    color: #626262;
    color: ${prop => (prop.active ? "#50AFF4;" : "#626262;")};
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    width: 140%;
    height: 5px;
    background-color: #50aff4;
    border-radius: 4px 4px 0 0;
    opacity: ${prop => (prop.active ? "1;" : "0;")};
  }
`;

export const TabContent = styled.div`
  padding: 15px;

  /* > div:not(:last-child) {
    .group-separator {
      border-bottom: 1px solid #ebebeb;
    }
  } */
`;
